var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "../../interface/IVueDialog";
var MessageDialog = (function (_super) {
    __extends(MessageDialog, _super);
    function MessageDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service_status = null;
        _this.msg = '';
        return _this;
    }
    MessageDialog.prototype.created = function () {
    };
    MessageDialog.prototype.mounted = function () {
        this.service_status = this.service_status;
        this.msg = this.msg;
    };
    MessageDialog.prototype.openService = function () {
        this.$closeDialog();
        this.$emit('openService', this.service_status);
    };
    MessageDialog.prototype.payService = function () {
        this.$closeDialog();
        this.$emit('payService', this.service_status);
    };
    MessageDialog = __decorate([
        Component
    ], MessageDialog);
    return MessageDialog;
}(IVueDialog));
export default MessageDialog;
